// 命名空间：区分项目
const NAME_SPACE = 'GT_PC';

// 是否同意隐私协议
export const STORAGE__AGREE_POLICY = `AGREE_POLICY(${NAME_SPACE})`;
export const STORAGE__QING_LANG = `QING_LANG(${NAME_SPACE})`;
export const STORAGE__NOTICE = `NOTICE(${NAME_SPACE})`;
